import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Magnifying Glass Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "m250.615 236.976-60.326-60.314C242.59 113.87 207.305 18.006 126.774 4.107 46.244-9.793-19.134 68.698 9.094 145.389c25.34 68.843 111.202 91.85 167.568 44.9l60.314 60.326c5.25 5.25 14.214 2.848 16.135-4.323a9.64 9.64 0 0 0-2.496-9.316M22.104 108.853c0-66.78 72.29-108.517 130.123-75.127s57.833 116.864 0 150.254a86.76 86.76 0 0 1-43.374 11.622c-47.888-.053-86.696-38.86-86.749-86.749" }, null, -1)
  ])))
}
export default { render: render }